<template>
  <transition name="transition-fade">
    <div
        v-show="checked"
        data-checkmark
        :class="classList"
        data-test-id="checkmark"
    >
      <vue-feather type="check"
                   :class="classListIcon"></vue-feather>
    </div>
  </transition>
</template>

<script>
import VueFeather from 'vue-feather';

/**
 * Checkmark.vue
 */
export default {
  components: {
    VueFeather,
  },

  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    customSize: {
      type: Number
    }
  },
  data () {
    return {
      size: '5'
    }
  },
  computed: {
    classList () {
      return [
        'w-' + this.size,
        'h-' + this.size,
        'rounded-full border-2 text-white flex justify-center items-center bg-blue-500 opacity-1 border-blue-500',
      ]
    },
    classListIcon () {
      return [
        'w-3 h-3',
      ]
    },
  },
  mounted () {
    this.size = this.customSize ? this.customSize.toString() : this.size
  }
}
</script>